const SERVERDOMAIN = "ticket_booking_4_2_function";

//Get All Vouchers
async function GetVouchers(_eventId) {
  try {
    const response = await fetch(`/server/${SERVERDOMAIN}/getVouchers?eventId=${_eventId}`, { method: "POST" });

    if (!response.ok) throw new Error(`Lỗi khi lấy Voucher: ${response}`);

    const data = await response.json();

    if (data && data.code === 9280) {
      console.log("No vouchers found for this event. Defaulting to empty array.");
      return { data: [] }; 
    }

    return data;
  } catch (error) {
    console.error("Lỗi khi lấy Voucher:", error);
    return { data: [] };
  }
}

//Get Current Event
async function GetCurrentEvent(_eventId) {
  try {
    const response = await fetch(`/server/${SERVERDOMAIN}/getEvent?event_Id=${_eventId}`, { method: "POST" });

    if (!response.ok) throw new Error(`Lỗi khi lấy Event: ${response}`);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Lỗi khi lấy Event:", error);
    throw error;
  }
}

//Get CSMO Members
async function GetHoiVienCSMO() {
  try {
    const response = await fetch(`/server/${SERVERDOMAIN}/getHoiVienCSMO`, {
      method: "POST",
    });

    if (!response.ok) throw new Error(`Lỗi khi lấy hội viên: ${response.status}`);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Lỗi khi lấy hội viên:", error);
    throw error;
  }
}

//
// Database API Connections
//
async function InsertNewTicketBooking(currentQrString, bookingData) {
  const { formData, TicketType, NoOfTicket, khoaHoc, errorCount, errorLog } = bookingData;

  let requestBody = {
    data: {
      Payment_Status: "Waiting",
      First_name: formData["First_name"],
      Last_name: formData["Last_name"],
      Mobile: formData["Mobile"],
      Gender: formData["Gender"],
      Ticket_type: TicketType,
      Voucher: formData["Voucher"],
      Email: formData["Email"],
      Price: formData["Price"],
      Ticket_Price: formData["Ticket_price"],
      Merchant_Request_Id: formData["Merchant_Request_Id"],
      Number_of_Tickets: NoOfTicket,
      Event_name: formData["Event_name"],
      Event_code: formData["Event_code"],
      Payon_QR_String: currentQrString,
      Company: formData["Company"],
      ZNS_ID: formData["ZNS_ID"],
      Zeptomail_ID: formData["Zeptomail_ID"],
      Address: formData["Address"],
      Tax_code: formData["Tax_code"],
      LayHoaDon: formData["LayHoaDon"],
      Position: formData["Position"],
      hoivien_csmo_lookup: formData["hoiVienId"],
      hoi_vien_gioi_thieu: formData["hoiVienGioiThieuId"],
      Dang_ky_CSMO: formData["isHoiVienDangKy"],
      Hoi_vien_CSMO: formData["isHoiVienChinhThuc"],
      khoa_hoc: khoaHoc,
      Error_count: errorCount,
      Error_log: errorLog,
    },
    result: {
      fields: ["ID", "First_name", "Last_name", "Payon_QR_String"],
      message: true,
      tasks: true,
    },
  };

  try {
    const response = await fetch(`/server/${SERVERDOMAIN}/submitTicket`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();
    if (data.code !== 3000) console.error(`Lỗi khi tạo Ticket: ${data}`);

    return data;
  } catch (error) {
    console.error("Lỗi khi tạo Ticket:", error);
    InsertErrorLog(error, requestBody);
  }
}

async function InsertErrorLog(error, body) {
  let requestBody = {
    data: {
      Details: error,
      Status: "New",
      Request_Body: body,
    },
    result: {
      fields: ["ID"],
      message: true,
      tasks: true,
    },
  };

  try {
    const response = await fetch(`/server/${SERVERDOMAIN}/submitErrorLog`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Lỗi khi tạo Error Log:", error);
    throw error;
  }
}

export { GetVouchers, GetCurrentEvent, GetHoiVienCSMO, InsertNewTicketBooking, InsertErrorLog };
